module.exports = __webpack_public_path__ + "static/media/Illus-Employee_4@3x.f38c4ef1.png";